import { Box, Modal } from "native-base";
import {
  Image, Platform, StyleSheet, Text, TouchableHighlight, TouchableOpacity, View
} from "react-native";
import Entypo from '@expo/vector-icons/Entypo';
import { useCallback, useEffect, useState } from "react";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import Feather from '@expo/vector-icons/Feather';
import FontAwesome6 from '@expo/vector-icons/FontAwesome6';
import Fontisto from '@expo/vector-icons/Fontisto';
import FontAwesome from '@expo/vector-icons/FontAwesome';

import { PuzzleThemeCharacter } from "../data/types";
import { RootStackParamList } from "../navigation";
import { useTypedSelector } from "../redux/store";
import { UserAPI } from "../data/api";
import { useDispatch } from "react-redux";
import { PayTipModal } from "../components/pay/payTipModal";
import { PayAPI } from "../data/payApi";
import PhoneScreen from "./PhoneScreen";
import { PayTipCoin } from "../components/pay/payTipCoin";
import { db } from "../data/database";
import { supabase } from "../lib/supabase";
import ConfigUserModal from "../components/tips/configUserModal";
import { User } from "@supabase/supabase-js";
import { PuzzleAPI } from "../data/puzzleApi";
import { ThemeList } from "../components/themeList";
import { AlbumList } from "../components/albumList";
import { setUserInfo } from "../redux/reducers/authSlice";
import { LoginTip } from "../components/tips/loginTip";

type Props = NativeStackScreenProps<RootStackParamList, 'Detail'>;

export default function DetailScreen({
  navigation, route
}: Props){
  // const { character } = route.params || {};

  const dispatch = useDispatch();
  const [character, setCharacter] = useState<PuzzleThemeCharacter>({
    id: "", name: "Jeni", description: "Tiktok Model, Singer", role_img_url: "",
    imgs_number: 0, rewarded_video_count: 0, price: "",
    price_num: 0, disabled: false, role_name: "",
    backgroundStory: ""
  });
  
  const [albums, setAlbums] = useState<PuzzleThemeCharacter[]>([]);
  const [bgImage, setBgImage] = useState("");

  // const [roleDisplays, setRoleDisplays] = useState<RoleDisplayImage[]>([]);
  const [selectedTheme, setSelectedTheme] = useState<PuzzleThemeCharacter | null>(null);
  const [phoneOpen, setPhoneOpen] = useState(false);
  const userCurrent = useTypedSelector((state) => state.userCurrent);
  const userInfo = useTypedSelector(state=> state.userInfo );
  const [phoneMin, setPhoneMin] = useState("xx");

  const isSubscribed = userCurrent.sub_list.includes(character.name);

  const [checkPay, setCheckPay] = useState({
    coin: 50, index: 0, open: false, tips: "Unlock this image with coins"
  });

  const [coinTipOpen, setCoinTipOpen] = useState(false);
  const [configOpen, setConfigOpen] = useState(false);
  const [createTipOpen, setCreateTipOpen] = useState(false);
  const [loginTip, setLoginTip] = useState(false);

  const getJeniCharacters = async () => {
    try {
      const cachedData = await db.getCachedCharacters();
      let regex = "Jeni Free";
      if(Platform.OS === "web"){
        let path = window.location.pathname;
        let ansName = path.replace("/", "");
        if(ansName) regex = ansName.replace("%20", " ");
      };
      
      if (cachedData) {
        let charact_use = cachedData.characters.find(item=> item.role_name.toLowerCase() === regex);
        if(charact_use){ setCharacter(charact_use); };
        return;
      }
      // Get characters from Supabase via the API
      const charactersData = await PuzzleAPI.getPuzzleTheme();
      let list = charactersData?.list || [];
      await db.cacheCharacters(list);
      let charact_use = list.find(item=> item.name === regex);
      if(charact_use){
        setCharacter(charact_use);
      };
    } catch (err) {
      console.log(err);
    }
  };

  // const loadCharacters = async (theme_id: string) => {
  //   if(!theme_id) return;
  //   // if (loading || (!hasMore && !refresh)) return;
  //   try {
  //     setLoading(true);
  //     const charactersData = await PuzzleAPI.getPuzzleImages(theme_id);
  //     let list = charactersData?.list || [];
  //     list.forEach((item,idx)=>{
  //       item.coin = COIN_ARR_NUMBER[idx] || 50;
  //       if(!item.url.includes("http")){ item.url = "https://puzzle.snackbook.cc" + item.url; }
  //       if(!item.thumbnail_url.includes("http")){
  //         item.thumbnail_url = "https://puzzle.snackbook.cc" + item.thumbnail_url;
  //       }
  //     });
  //     setMedias(list);
  //   } catch (err) {
  //     console.log(err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  // albums, setAlbums
  const getAlbumData = async () => {
    try {
      const charactersData = await PuzzleAPI.getPuzzleTheme();
      let list = charactersData?.list || [];
      if(list[0]){ setBgImage(list[0].role_img_url); }
      handleRedata(list);
    } catch (err) {
      console.log(err);
    }
  };

  const handleRedata = (themes: PuzzleThemeCharacter[])=>{
    let list = [...themes];
    let unlock_theme = userCurrent.unlock_theme || [];

    list.forEach((item, idx)=>{
      if(
        unlock_theme.includes(item.id) || item.name === "free"
      ){
        item.disabled = false;
      }else{
        item.disabled = true;
      }
      item.price_num = parseInt(item.price);
    });
    setAlbums(list);
  };

  useEffect(()=>{
    const min = Math.floor(userCurrent.coins / 300);
    setPhoneMin(min.toString());
    if(userCurrent.id){
      handleRedata(albums);
    }
  },[character, userCurrent]);

  const getPhoneHandle = (user: User)=>{
    let issess = false;
    try {
      if(Platform.OS === "web" && typeof window !== "undefined"){
        issess = window.location.search.includes("success");
        window.history.replaceState(
          {}, document.title, window.location.pathname 
        )
      }
    } catch (err) {
      console.log(err);
    }
    let meta_phone = user.phone;
    if( !meta_phone && user.user_metadata?.phone ){
      meta_phone = user.user_metadata.phone || "";
    }
    if(!meta_phone && issess){
      setConfigOpen(true);
    }
  };

  const getWindowParam = (key: string)=>{
    if(Platform.OS === "web" && typeof window!== "undefined"){
      let path = window.location.search;
      let param = new URLSearchParams(path);
      return param.get(key) || "";
    }
    return ""
  }

  const getUserInfo = async ()=>{
    const { data, error } = await supabase.auth.getUser();
    // getJeniCharacters();
    if(!error){
      dispatch(setUserInfo(data.user));
      let be_invited = getWindowParam("invite_code");
      UserAPI.getCurrentUser(dispatch, be_invited);
      getPhoneHandle(data.user);
    }else{
      supabase.auth.onAuthStateChange((event, session) => {
        if (event === 'SIGNED_IN' && session) {
          let be_invited = getWindowParam("invite_code");
          UserAPI.getCurrentUser(dispatch, be_invited);
          // getJeniCharacters();
          const isCreateTip = localStorage.getItem("create_tip");
          if(!isCreateTip){
            // setCreateTipOpen(true);
            localStorage.setItem("create_tip", "true");
          }
          dispatch(setUserInfo(data.user))
          getPhoneHandle(session.user);
        } else if (event === 'SIGNED_OUT') {
          dispatch(setUserInfo(null))
        }
      });
    }
  };

  useEffect(()=>{
    getUserInfo();
    getAlbumData();
  }, []);

  const handleThemePress = useCallback((
    item: PuzzleThemeCharacter,
    index: number
  )=>{
    if(!userInfo || userInfo.is_anonymous){
      setLoginTip(true); return;
    };
    if(item.price === "sub-only" && !isSubscribed){
      navigation.navigate("ExpertPay", {
        character: item,
        images: albums.map(item=> item.role_img_url )
      });
      return;
    }
    if(item.disabled){
      setCheckPay({
        coin: item.price_num, index: index, open: true,
        tips: "Unlock this Album with coins"
      })
    }else{
      UserAPI.updateUserCacheDatas("Look Album: " + item.role_name);
      setBgImage(item.role_img_url);
      setSelectedTheme( item );
    };
  },[userInfo, albums]);

  const goMessageChats = ()=>{
    // if(!isSubscribed){ goExpretPay(); return; }
    if(!userInfo || userInfo.is_anonymous){
      setLoginTip(true); return;
    }
    if(userCurrent.coins < 50){
      setCoinTipOpen(true); return;
    };
    UserAPI.updateUserCacheDatas("Call Me");
    setPhoneOpen(true);
    return;
    // let {routes} = navigation.getState();
    // let end_obj = routes[routes.length - 2];
    // if(end_obj && end_obj.name === "Message"){
    //   navigation.goBack();
    // }else{
    //   navigation.navigate("Message", {character});
    // };
  };
  
  const goMessageWatsapp = ()=>{
    UserAPI.updateUserCacheDatas("Open Watsapp");
    if(typeof window !== "undefined"){
      window.open("https://wa.me/+14254105392", "_blank"); 
    }
  };

  const goActivityScreen = ()=>{
    navigation.navigate("Activity", {});
  }

  const goExpretPay = ()=>{
    navigation.navigate("ExpertPay", {character, images: albums.map(item=> item.role_img_url ) });
  };

  const goSupport = ()=>{
    navigation.navigate("Support", {});
  }

  const goUserProfile = ()=>{
    navigation.navigate("Profile", {});
  };

  const payChanges = (state: string)=>{
    setCheckPay({ coin: 50, index: 0, open: false, tips: "Unlock this image with coins" });
    if(state === "success"){
      
      let { unlock_theme } = userCurrent;
      let copy_theme = [...unlock_theme];
      copy_theme.push( albums[checkPay.index].id );
      PayAPI.updateProfiles(
        dispatch, {unlock_theme: copy_theme}
      );
    }else{
      navigation.navigate("GemPay", {character});
    }
  };

  return (
    <Box style={{
      backgroundColor: "#191B2C",
      height: "100%", width: "100%", overflow: "hidden"
    }}>
      {/* <Button style={{
        backgroundColor: "rgba(0,0,0,0.5)",
        borderRadius: 100, position: "absolute",
        top: 10, left: 10, padding: 4, zIndex: 9,
      }} onPress={()=> navigation.goBack() }>
        <Entypo name="chevron-left" size={24} color="#FFFFFF" />
      </Button> */}
      <View style={styles.nav_top_ctx}>
        <TouchableOpacity style={{
          height: 32, alignItems: "center", justifyContent: "center",
          borderRadius: 12,
          paddingLeft: 10, paddingRight: 10,
          backgroundImage: "linear-gradient(to bottom, rgb(148,9,255), rgb(173,8,255))",
          flexDirection: "row",
        }} onPress={goUserProfile}>
          {!userInfo || userInfo.is_anonymous ? (
            <Text style={{ color: "#FFFFFF", fontSize: 14 }}>
              Sign In
            </Text>
          ) : (
            <Feather name="user" size={20} color="#FFFFFF" />
          )}
        </TouchableOpacity>
        <View style={{ flex: 1 }} />
        <TouchableOpacity style={{
          height: 24, width: 24, alignItems: "center", justifyContent: "center",
          borderRadius: 100, backgroundColor: "rgba(0,0,0,0.5)",
        }} onPress={goSupport}>
          <FontAwesome name="support" size={16} color="#FFFFFF" />
        </TouchableOpacity>
        <TouchableOpacity style={{
          height: 24, width: 24, alignItems: "center", justifyContent: "center",
          borderRadius: 100, backgroundColor: "rgba(0,0,0,0.5)",
        }} onPress={goExpretPay}>
          <FontAwesome6 name="gift" size={16} color="rgb(221,110,255)" />
        </TouchableOpacity>
        <TouchableOpacity style={{
          flexDirection: 'row',
          alignItems: 'center',
          gap: 10,
          borderRadius: 20,
          padding: 2,
          paddingLeft: 12,
          paddingRight: 12,
          borderWidth: 1,
          borderColor: "#007AFF",
          borderStyle: "solid",
          backgroundColor: "rgba(0,0,0,0.5)"
        }} onPress={()=> navigation.navigate("GemPay", {character}) }>
          <Fontisto name="database" size={12} color="#FFFFFF" />
          <Text style={{ color: '#FFFFFF', fontSize: 14 }}>{userCurrent.coins}</Text>
        </TouchableOpacity>
      </View>
      
      <View style={{
        position: "absolute", top: 60, right: 6,
        zIndex: 9
      }}>
        <TouchableOpacity onPress={goActivityScreen}>
          <Image source={require('../assets/gift1.png')}
            style={{ width: 54, height: 54 }} />
          <Text style={{
            fontSize: 12, color: "#FFFFFF", textAlign: "center",
            textShadowColor: "rgb(148,9,255)", fontWeight: "600",
            textShadowRadius: 10,
          }}>Refer</Text>
        </TouchableOpacity>
      </View>

      <View style={{ overflow: "scroll", flex: 1 }}>
        <View style={{
            width: "100%", overflow: "hidden",
            height: 500, alignItems: "flex-start"
          }}>
          <Image source={{ uri: bgImage }}
            style={{ width: '100%', flex: 1 }} resizeMode="cover"
          />
          <View style={{
            position: "absolute", bottom: 0, left: 0, width: "100%",
            height: 120, padding: 10, paddingTop: 40,
            backgroundImage: "linear-gradient(to top, rgba(25,27,44, 0.6), rgba(0,0,0,0))",
          }}>
            <Text style={{ fontSize: 24, fontWeight: "bold", color: "#FFFFFF" }}>
              {character.name}
            </Text>
            <Text style={{ fontSize: 14, color: "#AAAAAA", marginTop: 4 }}>
              {character.description}
            </Text>
          </View>
        </View>
        {selectedTheme ? (
          <AlbumList themeInfo={selectedTheme}
            onClose={()=> setSelectedTheme(null) } />
        ) : (
          <ThemeList albums={albums} onChange={handleThemePress} />
        )}
      </View>
      <View style={{ padding: 10, justifyContent: "center" }}>
        <View style={{
          flexDirection: "row", gap: 10, alignItems: "center",
        }}>
          <TouchableOpacity style={{
            height: 40, borderRadius: 6, paddingLeft: 10, paddingRight: 10, flex: 1,
            backgroundImage: "linear-gradient(to bottom, rgb(148,9,255), rgb(173,8,255))",
            flexDirection: "row", alignItems: "center",
          }} onPress={goMessageWatsapp}>
            <View style={{
              flex: 1, height: "100%", justifyContent: "center",
              alignItems: "center", flexDirection: "row", gap: 10
            }}>
              <Entypo name="message" size={18} color="#FFFFFF" />
              <Text style={{
                fontSize: 18, color: "#FFFFFF", fontWeight: "700"
              }}>Chat Me</Text>
            </View>
          </TouchableOpacity>

          <TouchableOpacity style={{
            height: 40, borderRadius: 6, paddingLeft: 10, paddingRight: 10, flex: 1,
            backgroundImage: "linear-gradient(to bottom, rgb(148,9,255), rgb(173,8,255))",
            flexDirection: "row", alignItems: "center",
          }} onPress={goMessageChats}>
            <Text style={{ fontSize: 16 }}>🔥</Text>
            <View style={{
              flex: 1, height: "100%", justifyContent: "center",
              alignItems: "center", flexDirection: "row", gap: 10
            }}>
              <FontAwesome6 name="phone" size={18} color="#FFFFFF" />
              <Text style={{
                fontSize: 18, color: "#FFFFFF", fontWeight: "700"
              }}>Call Me</Text>
            </View>
            <Text style={{ fontSize: 16 }}>🔥</Text>
          </TouchableOpacity>
        </View>
        <Text style={{
          color: "#AAAAAA", fontSize: 12, textAlign: "center",
          marginTop: 6
        }}>
          You have {userCurrent.coins} coins, you can call {phoneMin} min
        </Text>
      </View>

      <PayTipModal
        open={ checkPay.open } setOpen={()=>{
          setCheckPay({...checkPay, open: false});
        }} onChange={payChanges}
        tipText="Unlock this image with coins" delCoins={ checkPay.coin } />

      <PayTipCoin
        open={ coinTipOpen } setOpen={()=> setCoinTipOpen(false) }
        onChange={()=>{
          setCoinTipOpen(false);
          if(!isSubscribed){
            goExpretPay();
          }else{
            payChanges("error");
          }
        }}
        delCoins={50} />

      {/* <CreateTipModal
        open={ createTipOpen } setOpen={()=> setCreateTipOpen(false) }
        onChange={()=>{
          setCreateTipOpen(false);
          goMessageChats();
        }} /> */}
      <LoginTip
        open={ loginTip } setOpen={()=> setLoginTip(false) }
        onChange={()=>{
          setLoginTip(false);
          goUserProfile();
        }} />
      
      <Modal isOpen={configOpen} size="full" bg="black.700:alpha.70"
        justifyContent="center" alignItems="center"
        style={{
          width: "100%", maxWidth: 460,
          marginLeft: "auto", marginRight: "auto",
        }}>
        { configOpen && (
          <ConfigUserModal
            setOpen={()=>{ setConfigOpen(false) }}
            onChange={()=>{}} />
        ) }
      </Modal>
      
      {phoneOpen && (
        // zindex = 11
        <PhoneScreen character={character}
          onHangUp={(state?: string)=> {
            if(state === "error"){
              setCoinTipOpen(true);
            };
            setPhoneOpen(false)
          } } />
      )}
    </Box>
  )
}

const styles = StyleSheet.create({
  bg_image: {
    width: "100%",
    height: "150%",
    opacity: 0.7,
  },
  grid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    paddingTop: 10,
  },
  nav_top_ctx: {
    position: "absolute", flexDirection: "row", alignItems: "center",
    gap: 10, top: 0, left: 0, zIndex: 9,
    paddingLeft: 6, paddingRight: 6, width: "100%",
    paddingTop: 8, paddingBottom: 8,
  },
})